import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ContactFieldSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full flex-col flex-wrap justify-center gap-y-5 lg:-ml-5 lg:w-[calc(100%+20px)] lg:flex-row">{Array.from(Array(12).keys()).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ContactFieldSkeleton;
function _temp(el, index) {
  return <div className="w-full sm:basis-1/2 lg:pl-5" key={index}><div className="bg-skeleton-primary my-3 w-full animate-pulse rounded-lg py-3 text-transparent">.</div></div>;
}